import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
class CarsAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        // Load alternative vehicle data object by internal auto.de ID
        Object.defineProperty(this, "getCarData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, withJWT) => {
                return this.privateRequest('get', `car/${id}`)
                    .then((response) => response.data);
            }
        });
        Object.defineProperty(this, "getAlternativeCarImages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, withJWT) => {
                return this.privateRequest('get', `car/${id}/images`)
                    .then((response) => response.data);
            }
        });
        Object.defineProperty(this, "importAlternative", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId, data) => {
                return this.privateRequest('post', `car/${carId}/sell`, data)
                    .then((response) => {
                    return response.data;
                });
            }
        });
        this.setConfig(config);
    }
}
export default new CarsAPI({ baseURL: config.alternativeCarsAPI.url });
